import { Models } from '@rematch/core';
import { clientModel } from './client';
import { userModel } from './user';
import { modalsModel } from './modals';
import { alertsModel } from './alerts';
import { statementModel } from './statements';
import { contactModel } from './contact';
import { contractsModel } from './contracts';
import { taxOfficeModel } from './taxOffice';
import { productModel } from './product';
import { agreementsModel } from './agreements';
import { notificationsModel } from './notifications';
import { paymentModel } from './payment';
import { applicationModel } from './application';
import { documentsModel } from './documents';
import { pwaModel } from './pwa';
import { enteredEmailsModel } from './enteredEmails';
import { processStepModel } from './processStep';
import { referenceDataModel } from './referenceData';
import { auditEventsModel } from './auditEvents';
import { contractAgreementsModel } from './tempContractAgreement';

export interface RootModel extends Models<RootModel> {
  client: typeof clientModel;
  contracts: typeof contractsModel;
  contractsAgreements: typeof contractAgreementsModel;
  user: typeof userModel;
  modals: typeof modalsModel;
  alerts: typeof alertsModel;
  contact: typeof contactModel;
  statements: typeof statementModel;
  product: typeof productModel;
  taxOffice: typeof taxOfficeModel;
  agreements: typeof agreementsModel;
  notifications: typeof notificationsModel;
  payment: typeof paymentModel;
  application: typeof applicationModel;
  documents: typeof documentsModel;
  pwa: typeof pwaModel;
  enteredEmails: typeof enteredEmailsModel;
  processStep: typeof processStepModel;
  referenceData: typeof referenceDataModel;
  auditEvents: typeof auditEventsModel;
}

export const models: RootModel = {
  client: clientModel,
  user: userModel,
  modals: modalsModel,
  alerts: alertsModel,
  contact: contactModel,
  contracts: contractsModel,
  contractsAgreements: contractAgreementsModel,
  statements: statementModel,
  product: productModel,
  taxOffice: taxOfficeModel,
  agreements: agreementsModel,
  notifications: notificationsModel,
  payment: paymentModel,
  application: applicationModel,
  documents: documentsModel,
  pwa: pwaModel,
  enteredEmails: enteredEmailsModel,
  processStep: processStepModel,
  referenceData: referenceDataModel,
  auditEvents: auditEventsModel
};
